var map = {
	"./backgrounds/home.webp": 764,
	"./backgrounds/outside-animation-return.svg": 9734,
	"./backgrounds/outside-animation.svg": 1611,
	"./backgrounds/playgound-issues.webp": 8087,
	"./backgrounds/school-2c-issues.svg": 4096,
	"./backgrounds/school-3c-lunch.svg": 811,
	"./backgrounds/school-3c.svg": 5836,
	"./backgrounds/school-8a-issues.svg": 1732,
	"./backgrounds/school-8a-phones.svg": 3723,
	"./backgrounds/school-8a.svg": 9395,
	"./backgrounds/school-hall-kids.svg": 3011,
	"./backgrounds/school-teachers-room-people.svg": 6263,
	"./backgrounds/school.webp": 3995,
	"./backgrounds/schoolyard-backdrop.svg": 6148,
	"./backgrounds/schoolyard-foreground.webp": 8759,
	"./bird.svg": 9978,
	"./blackboard.svg": 6120,
	"./characters/angry-student.svg": 4379,
	"./characters/cleaning-lady.svg": 9392,
	"./characters/manager.svg": 1567,
	"./characters/secretary.svg": 3388,
	"./characters/substitute.svg": 2154,
	"./characters/test.svg": 9306,
	"./dev/icon-menu.svg": 2960,
	"./icons/icon-arrow-down-red.svg": 9288,
	"./icons/icon-arrow-down.svg": 1466,
	"./icons/icon-arrow-right.svg": 332,
	"./icons/icon-audio-pause-blue.svg": 6014,
	"./icons/icon-audio-pause.svg": 6697,
	"./icons/icon-audio-play-blue.svg": 5168,
	"./icons/icon-audio-play.svg": 7283,
	"./icons/icon-checkmark.svg": 9369,
	"./icons/icon-choose.svg": 5377,
	"./icons/icon-correct.svg": 5200,
	"./icons/icon-cross-white.svg": 5146,
	"./icons/icon-drag.svg": 6204,
	"./icons/icon-flip-to-landscape.svg": 8863,
	"./icons/icon-home.svg": 5943,
	"./icons/icon-language.svg": 816,
	"./icons/icon-loading-white.svg": 1998,
	"./icons/icon-loading.svg": 2850,
	"./icons/icon-lock.svg": 4263,
	"./icons/icon-logout-2.svg": 545,
	"./icons/icon-logout.svg": 8732,
	"./icons/icon-next.svg": 9133,
	"./icons/icon-star-filled.svg": 8915,
	"./icons/icon-star.svg": 9638,
	"./icons/icon-wrong.svg": 2285,
	"./languages/da.svg": 6150,
	"./languages/en.svg": 1202,
	"./logo-cgl.svg": 3407,
	"./logo-vikarland.svg": 1441,
	"./modules/tasks/task-intro/angry-student.svg": 1294,
	"./modules/tasks/task-intro/printer.svg": 9407,
	"./modules/tasks/task-intro/secretary-calling.svg": 482,
	"./modules/tasks/task-intro/shelf.svg": 5119,
	"./splash.svg": 4590
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;